import React, { useEffect, useRef, useState } from 'react'
import { dispatchHandler } from '../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../../helper/permissions';
import GenericFormHeaderComponent from '../forms/GenericFormHeaderComponent';
import { Star, StarHalf, SquareArrowOutUpRight, FileClock, Check, HandCoins, ChevronRight, FileText, User } from "lucide-react";
import GenericCustomButton from '../GenericCustomButton';
import GenericTabsComponent from '../GenericTabsComponent';
import Icons from '../../assets/icons';
import ParentModal from '../ParentModal';
import ViewAllVendorDetails from './ViewAllVendorDetails';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import LanguageTranslator from '../../locals/LanguageTranslator';
import {motion} from 'framer-motion';
import { useAcessVendorPortal } from '../../helper/hooks/helperHook';
import { formatNumber } from '../../helper/genericFunction';
import VendorDetailsOpenPO from './VendorDetailsOpenPO';
import TableSkeleton from '../../components/dashboard/orderTracking/TableSkeleton';
import { Tooltip as AntdTooltip, Progress } from 'antd';
import GenericSpinnerLoader from '../../loaders/GenericSpinnerLoader';
import GenericMediaViewModal from '../media/GenericMediaViewModal';
import { getFileNameFromExt, getFileTypeFromUrl } from '../../helper/helperTableFunctions';
import TextWithTooltip from '../TextWithTooltip';


function VendorDetailsModal(props) {
    const dispatch = useDispatch()
    const digivendStore = useSelector((state) => state.digivendStore)
    const authStore = useSelector((state) => state.authStore);
    const getVendorProfileData = useSelector((state) => state.generalStore.getVendorProfileData)
    const getAllOrdersData = useSelector((state) => state.digivendStore.getAllOrdersData)
    const getLedgerReportData = useSelector((state) => state.reportsAndAnalyticsStore.getLedgerReportData)


    const accessVendorPortal = useAcessVendorPortal();

    const [currentTab, setCurrentTab] = useState('overview');
    const [currentTabData, setCurrentTabData] = useState(null);
    const [selectedModal, setSelectedModal] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [pieChartsActiveIndex, setPieChartsActiveIndex] = useState(null)
    const [tableHeadersMap, setTableHeadersMap] = useState({
            main: {
                name: "Main",
                key: "ENT_PENDING_ALL",
            },
        })
    const [loading, setLoading] = useState({});
    const [currPage, setCurrPage] = useState(1);
    const [percentageData, setPercentageData] = useState({});

    let observerTarget = useRef();

        // The ref of the top most element inside the comment here
    const lastListElementRef = (node) => {
        console.log('lastListElementRef : start')
        if (getLedgerReportData?.isLoading) return;
        console.log('lastListElementRef : second')
        
        if (observerTarget?.current) observerTarget.current.disconnect();
        console.log('lastListElementRef : third')
        observerTarget.current = new IntersectionObserver(entries => {
            console.log("entry intersecting", entries?.[0].isIntersecting);
            if (entries?.[0].isIntersecting) {
                // So that the state current page and max page state gets updated
                // getComments();
                // console.log('entry intersecting : if statement')
                if(currPage < getLedgerReportData?.data?.maxPage) {
                    setCurrPage(prev => prev+1)
                }
            }
        })
        if (node) observerTarget.current.observe(node);
    }

    const getApiConfig = ()=>{
        switch(currentTab) {
            case "overview":
                return {
                    apiName: 'getVendorProfileRequest',
                    payload: {
                        slCode: props.vendorDetailsConfig?.vendorCode || ""
                    },
                    getPermissionKey: getPermissionKey("common", "commonfunctionality", "view")
                };
            case "openPo":
                return {
                    apiName: 'getAllOrdersRequest',
                    payload: {
                        type: 1,
                        pageNo: 1,
                        pageSize: 10,
                        sortedBy: "",
                        sortedIn: "",
                        search: "",
                        filter: {
                            // vendorName: "A Fashion"
                            slCode: props.vendorDetailsConfig?.vendorCode || ""
                        },
                        // status: currentTab,
                        isDashboardComment: 0,
                        displayName: "ENT_PENDING_ALL"
                    },
                    getPermissionKey: getPermissionKey("purchase", "orders", "view")
                };
            case "purchaseLedger":
                return {
                    apiName: 'getLedgerReportRequest',
                    payload: {
                        type: 1,
                        pageNo: currPage,
                        pageSize: 10,
                        sortedBy: "",
                        sortedIn: "",
                        search: "",
                        filter: {
                            slCode: props.vendorDetailsConfig?.vendorCode || ""
                        },
                        status: "",
                        isDashboardComment: 0,
                        displayName: "ENT_VENDOR_LEDGER"
                    },
                    getPermissionKey: getPermissionKey("reportsanalytics", "vendorledger", "view")
                };
            default:
                return null;
        }
    }

    const getData = ()=>{
        dispatchHandler(dispatch, getApiConfig()?.apiName, getApiConfig()?.payload, getApiConfig()?.getPermissionKey )
    }

    useEffect(() => {
        if(currentTab && currentTab !== 'openPo') {
            getData();
        }
    }, [currentTab, currPage]);

    useEffect(() => {
        if(authStore?.vendorOnboardingProgressPercentageData?.isSuccess) {
            setPercentageData(authStore?.vendorOnboardingProgressPercentageData?.data || {})
        }
    }, [authStore?.vendorOnboardingProgressPercentageData?.isSuccess]);

    useEffect(() => {
        if(getVendorProfileData?.isSuccess || getAllOrdersData?.isSuccess || getLedgerReportData?.isSuccess){
            if(getVendorProfileData?.isSuccess) {
                dispatchHandler(dispatch, 'vendorOnboardingProgressPercentageRequest', { customDomain: ["quality.supplymint.com", "localhost"].some(key => window.location.hostname.includes(key)) ? "http://localhost3000.supplymint.com" : window.location?.hostname, userId: getVendorProfileData?.data?.resource?.userId }, getPermissionKey("common", "commonfunctionality", "upload"))
            }
            if(currentTab === 'overview') {
                setCurrentTabData(getVendorProfileData?.data?.resource || null)
            } else if (currentTab === 'purchaseLedger') {
                // setCurrentTabData(prev =>  ([...(prev || []), ...getLedgerReportData?.data?.resource]) || null)
                setCurrentTabData(prev => {
                    const newData = currPage === 1 ? getLedgerReportData?.data?.resource : [...(prev || []), ...getLedgerReportData?.data?.resource]
                    return newData;
                })
            }
        }
    }, [getVendorProfileData?.isSuccess, getAllOrdersData?.isSuccess, getLedgerReportData?.isSuccess])

    const rating = '', onboardingProgress = percentageData?.overallPercentage;

    const renderRatingStars = (rating)=>{

        const stars = [];

        for (let i = 1; i <= 5; i++) {
            if (rating >= i) {
            stars.push(<Star key={i} size={14} color='#ECB80B' fill='#ECB80B' className="shrink-0" />);
            } else if (rating >= i - 0.5) {
            stars.push(<div className='relative'>
                <Star key={i} size={14} color='#DAE4EE' fill='#DAE4EE' className="shrink-0" />
                <StarHalf key={i} size={14} color='#ECB80B' fill='#ECB80B' className="shrink-0 absolute top-0 left-0" />
            </div>);
            } else {
            stars.push(<Star key={i} size={14} color='#DAE4EE' fill='#DAE4EE' className="shrink-0" />);
            }
        }

        return <div className="flex gap-1">{stars}</div>;
    }

    const handleChange = (type, data) => {
        switch (type) {
            case "accessVendorPortal": {
				accessVendorPortal({
					username: props.vendorDetailsConfig?.vendorCode || "",
				})
				break;
			}
            case "changeTab": {
                setCurrentTab(data)
                setCurrentTabData(null)
                setCurrPage(1)
            }
                break;
        
            default:
                setSelectedModal(type);
                setSelectedData(data);
                break;
        }
    }

    const ChartCustomTooltip = ({ active, payload }) => {
        console.log('active', active, payload)
        if (active && payload && payload.length) {
            return (
            <motion.div initial={{scale: .9, opacity: 0}} animate={{scale: 1, opacity: 1}} exit={{scale: .9, opacity: 0}} transition={{duration: .1}} style={{boxShadow: '0px 4.4px 4.4px 0px #00000040'}} className={`bg-white p-[8px] rounded-[10px] border border-[#EBEBEB]`}>
                <p className="mb-0 text-base font-semibold text-fontBlack">{payload[0].value}</p>
                <div className='flex items-center gap-1.5'>
                    {/* <div className={`shrink-0 w-[16px] h-[16px] bg-white rounded-full`} style={{ border: `6px solid ${payload[0]?.payload?.color}` }} ></div> */}
                    <p className="mb-0 text-[13px]">{payload[0].name}</p>
                </div>
            </motion.div>
            );
        }
        return null;
    };

    const expandFileData = (str = "") => {
        if (typeof str !== "string") return null;
        const [id, baseUrl, filePath, fileName, oldFileName] = str.split("|");

        const url = `${baseUrl}/${filePath}/${fileName}?response-content-disposition=inline`;
        return [{
            id: Number(id),
            filePath,
            fileName,
            oldFileName,
            url,
        }];
    }

    const ordersData = [
            {
                label: 'Pending PO',
                count: currentTabData?.po_asn_data?.pending_count || '',
                qty: currentTabData?.po_qty_amount_data?.pending_po_qty || '',
                amount: currentTabData?.po_qty_amount_data?.pending_po_amount || '',
                icon: <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#FF793F]'><FileClock size={17} strokeWidth={1.5} color='white' /></div>
            },
            {
                label: 'Total ASN',
                count: currentTabData?.po_asn_data?.asn_count || '',
                qty: currentTabData?.po_qty_amount_data?.asn_qty || '',
                amount: currentTabData?.po_qty_amount_data?.asn_amount || '',
                icon: <Icons.AsnQty/>
            },
            {
                label: 'Cancelled PO',
                count: currentTabData?.po_asn_data?.cancelled_count || '',
                qty: currentTabData?.po_qty_amount_data?.cancelled_po_qty || '',
                amount: currentTabData?.po_qty_amount_data?.cancelled_po_amount || '',
                icon: <Icons.CancelledQty/>
            },
            {
                label: 'Received PO',
                count: currentTabData?.po_asn_data?.received_count || '',
                qty: currentTabData?.po_qty_amount_data?.grc_qty || '',
                amount: currentTabData?.po_qty_amount_data?.grc_amount || '',
                icon: <div className='p-[5px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#03B675]'><div className='p-[3px] shrink-0 border-[1.5px] border-white rounded-full'><Check size={9} strokeWidth={2.5} color='white' className='shrink-0' /></div></div>
            },
        ]

        const productStatusData = [
            {
                label: 'Approved',
                count: currentTabData?.product_data?.approved_products || '',
                icon: <div className='w-[8px] h-[8px] shrink-0 rounded-full bg-[#03B675] ring ring-[#03B675] ring-opacity-20'></div>
            },
            {
                label: 'Rejected',
                count: currentTabData?.product_data?.rejected_products || '',
                icon: <div className='w-[8px] h-[8px] shrink-0 rounded-full bg-[#FD3757] ring ring-[#FD3757] ring-opacity-20'></div>
            },
            {
                label: 'Drafted',
                count: currentTabData?.product_data?.drafted_products || '',
                icon: <div className='w-[8px] h-[8px] shrink-0 rounded-full bg-[#636E72] ring ring-[#636E72] ring-opacity-20'></div>
            },
            {
                label: 'Submitted',
                count: currentTabData?.product_data?.submitted_products || '',
                icon: <div className='w-[8px] h-[8px] shrink-0 rounded-full bg-[#74B9FF] ring ring-[#74B9FF] ring-opacity-20'></div>
            },
        ]

        const modifiedDataForGraph = {
            total_products: currentTabData?.product_data?.total_products || '',
            graphData :[
                    {
                        name: 'Approved',
                        value: currentTabData?.product_data?.approved_products || '',
                        color: '#03B67599'
                    },
                    {
                        name: 'Rejected',
                        value: currentTabData?.product_data?.rejected_products || '',
                        color: '#FD375799'
                    },
                    {
                        name: 'Drafted',
                        value: currentTabData?.product_data?.drafted_products || '',
                        color: '#636E7299'
                    },
                    {
                        name: 'Submitted',
                        value: currentTabData?.product_data?.submitted_products || '',
                        color: '#74B9FF99'
                    },
                    {
                        name: 'Costing & Sample Request',
                        value: (currentTabData?.product_data?.costing_sampling_requested + currentTabData?.product_data?.costing_sampling_pending_approval) || '',
                        color: '#ECB80B99'
                    },
                ]
        }

        // setProductsGraphData(modifiedDataForGraph)

        const vendorDetails = {
            overview: [
                {
                    label: 'Email',
                    value: currentTabData?.supplier_details?.email || '',
                },
                {
                    label: 'Contact Person',
                    value: currentTabData?.supplier_details?.contact_person || '',
                },
                {
                    label: 'Contact Details',
                    value: currentTabData?.supplier_details?.mobile_no || '',
                },
                {
                    label: 'Portal Access',
                    value: currentTabData?.supplier_details?.portal_access || '',
                },
                {
                    label: 'Shipping Address',
                    value: currentTabData?.supplier_details?.shipping_address || '',
                },
                {
                    label: 'Aadhaar Details',
                    value: currentTabData?.supplier_details?.aadhar_no || '',
                    attachment: expandFileData(currentTabData?.supplier_details?.primary_contact_aadhaar_upload)?.[0] || ''
                },
                {
                    label: 'PAN Details',
                    value: currentTabData?.supplier_details?.pan_no || '',
                    attachment: expandFileData(currentTabData?.supplier_details?.pan_upload)?.[0] || ''

                },
                {
                    label: 'GST Number',
                    value: currentTabData?.supplier_details?.gstin_no || '',
                    attachment: expandFileData(currentTabData?.supplier_details?.gst_upload)?.[0] || ''
                },
            ],
            billingDetails: [
                {
                    label: 'GST Number',
                    value: currentTabData?.supplier_details?.billing_gstin_no || '',
                },
                {
                    label: 'State',
                    value: currentTabData?.supplier_details?.billing_state || '',
                },
                {
                    label: 'City',
                    value: currentTabData?.supplier_details?.billing_city || '',
                },
                {
                    label: 'GST State Code',
                    value: currentTabData?.supplier_details?.billing_state_code || '',
                },
                {
                    label: 'Billing Address',
                    value: currentTabData?.supplier_details?.billing_address || '',
                },
            ],
            shippingDetails: [
                {
                    label: 'GST Number',
                    value: currentTabData?.supplier_details?.shipped_gst_no || '',
                },
                {
                    label: 'State',
                    value: currentTabData?.supplier_details?.shipped_state_name || '',
                },
                {
                    label: 'City',
                    value: currentTabData?.supplier_details?.shipped_city_name || '',
                },
                {
                    label: 'GST State Code',
                    value: currentTabData?.supplier_details?.shipped_state_code || '',
                },
                {
                    label: 'Shipping Address',
                    value: currentTabData?.supplier_details?.shipping_address || '',
                },
            ],
            otherDetails: [
                {
                    label: 'Status',
                    value: currentTabData?.supplier_details?.vendor_status || '',
                },
                {
                    label: 'Due Days',
                    value: currentTabData?.supplier_details?.duedays || '',
                },
                {
                    label: 'Due Date Basis',
                    value: currentTabData?.supplier_details?.duedate_basis || '',
                },
                {
                    label: 'Delivery Buff Days',
                    value: currentTabData?.supplier_details?.delivery_buffdays || '',
                },
                {
                    label: 'QC Required',
                    value: currentTabData?.supplier_details?.is_qc ? 'Yes' : 'No' || '',
                },
                {
                    label: 'Invoice Required',
                    value: currentTabData?.supplier_details?.is_invoice ? 'Yes' : 'No' || '',
                },
            ]
        }

        const getRangeCardBgColor = (range='')=>{
            const modifiedRange = range?.toString()?.replace('%', '');
            if(modifiedRange < 40) {
                return '#FC38580F'
            } else if (modifiedRange < 60) {
                return '#FE9D0B0F'
            } else {
                return '#03B6750F'
            }
        }

        const getProgressColor = (range) => {
            const modifiedRange = range;
            if(modifiedRange < 40) {
                return '#FC3858'
            } else if (modifiedRange < 60) {
                return '#FE9D0B'
            } else {
                return '#03B675'
            }
        }

        const onPieEnter = (_, index) => {
            setPieChartsActiveIndex(index)
        }

    const renderPurchaseLedger = ()=>{

        const headersData = {
            transactionDate: 'Transaction Date',
            particulars: 'Particulars',
            credit: 'Credit',
            debit: 'Debit',
            balance: 'Closing Balance',
            creationTime: 'Creation Time'
        }

        const renderUpperSectionSkeleton = () => {
            return <div className='flex items-center gap-2'>
                    
                    <div className='generic-skeleton !h-[66px] w-[158px]'></div>
                    <span className='text-[13px] text-[#4A5D7A]'>+</span>
                    
                    <div className='generic-skeleton !h-[66px] w-[158px]'></div>
                    <span className='text-[13px] text-[#4A5D7A]'>-</span>

                    <div className='generic-skeleton !h-[66px] w-[158px]'></div>
                    <span className='mx-1 text-[13px] text-[#4A5D7A]'>=</span>

                    <div className='generic-skeleton !h-[66px] w-[158px]'></div>
            
                </div>
        }

        return <div className='h-full flex flex-col'>
                    {(getLedgerReportData?.isLoading && currPage === 1) ? renderUpperSectionSkeleton() : <div className='flex items-center gap-2'>
                    
                        <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                            <div>
                                <div className='group relative'>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><span className="bdrep-rupee-sign">&#8377;</span> {formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum)?.short || '-'}</LanguageTranslator>
                                    {formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum)?.full && <span className='generic-tooltip tooltip-bottom group-hover:visible group-hover:opacity-100'>{formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum)?.full || '-'}</span>}
                                </div>
                                <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Opening Balance</LanguageTranslator>
                            </div>
                            <div className='h-full flex flex-col justify-end items-center'>
                                {/* <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#03B675]'><Icons.TotalPo/></div> */}
                                <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={17} strokeWidth={1.5} color='white' /></div>
                            </div>
                        </div>
                        <span className='text-[13px] text-[#4A5D7A]'>+</span>

                        
                        <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                            <div>
                                <div className='group relative'>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><span className="bdrep-rupee-sign">&#8377;</span> {formatNumber(getLedgerReportData?.data?.tableLabelData?.credit_sum)?.short || '-'}</LanguageTranslator>
                                    {formatNumber(getLedgerReportData?.data?.tableLabelData?.credit_sum)?.full && <span className='generic-tooltip tooltip-bottom group-hover:visible group-hover:opacity-100'>{formatNumber(getLedgerReportData?.data?.tableLabelData?.credit_sum)?.full || '-'}</span>}
                                </div>
                                <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Total Credit</LanguageTranslator>
                            </div>
                            <div className='h-full flex flex-col justify-end items-center'>
                                <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#03B675]'><Icons.Credit/></div>
                            </div>
                        </div>
                        <span className='text-[13px] text-[#4A5D7A]'>-</span>

                        <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                            <div>
                                <div className='group relative'>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><span className="bdrep-rupee-sign">&#8377;</span> {formatNumber(getLedgerReportData?.data?.tableLabelData?.debit_sum)?.short || '-'}</LanguageTranslator>
                                    {formatNumber(getLedgerReportData?.data?.tableLabelData?.debit_sum)?.full && <span className='generic-tooltip tooltip-bottom group-hover:visible group-hover:opacity-100'>{formatNumber(getLedgerReportData?.data?.tableLabelData?.debit_sum)?.full || '-'}</span>}
                                </div>
                                <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Total Debit</LanguageTranslator>
                            </div>
                            <div className='h-full flex flex-col justify-end items-center'>
                                <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#FD3757]'><Icons.Debit/></div>
                            </div>
                        </div>
                        <span className='mx-1 text-[13px] text-[#4A5D7A]'>=</span>

                        <div className='px-3 py-2.5 bg-[#FAFAFA] rounded-[10px] grid grid-cols-[auto_auto] items-center gap-5'>
                            <div>
                                <div className='group relative'>
                                    <LanguageTranslator tag="h3" className='!mb-1.5 !text-base !font-semibold !text-fontBlack'><span className="bdrep-rupee-sign">&#8377;</span> {formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum + getLedgerReportData?.data?.tableLabelData?.credit_sum - getLedgerReportData?.data?.tableLabelData?.debit_sum)?.short || '-'}</LanguageTranslator>
                                    {formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum + getLedgerReportData?.data?.tableLabelData?.credit_sum - getLedgerReportData?.data?.tableLabelData?.debit_sum)?.full && <span className='generic-tooltip tooltip-bottom group-hover:visible group-hover:opacity-100'>{formatNumber(getLedgerReportData?.data?.tableLabelData?.balance_sum + getLedgerReportData?.data?.tableLabelData?.credit_sum - getLedgerReportData?.data?.tableLabelData?.debit_sum)?.full || '-'}</span>}
                                </div>
                                <LanguageTranslator tag="h5" className='!mb-0 !text-[11px] !font-normal !text-[#4A5D7A]'>Closing Balance</LanguageTranslator>
                            </div>
                            <div className='h-full flex flex-col justify-end items-center'>
                                <div className='p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={17} strokeWidth={1.5} color='white' /></div>
                            </div>
                        </div>
                
                    </div>}

                    <div className='mt-[12px] w-full h-full overflow-auto'>
                        <div className='table-v2 overflow-x-auto w-full h-full'>
                            {
                            (getLedgerReportData?.isLoading && currPage === 1) ? <TableSkeleton /> :
                                <table className='w-full'>
                                    <thead className='sticky top-[0] z-[2]'>
                                        <tr>
                                            {Object.keys(headersData || {}).map((key) =>
                                                <th key={key} className='!border-r-0'>
                                                    <LanguageTranslator tag='label' className='mb-0 !text-[11px] font-medium whitespace-nowrap'>{headersData?.[key] || '-'}</LanguageTranslator>
                                                </th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (!getLedgerReportData?.isLoading && !currentTabData?.length) ? 
                                            <tr><td colSpan="100"><label><LanguageTranslator>No Data Found!</LanguageTranslator>...</label></td></tr>
                                            : currentTabData?.map((item, index) => (
                                                <tr key={index} className='border-b border-borderSlateGrey'>
                                                    {
                                                        Object.keys(headersData || {}).map((key) =>
                                                            <td key={key} className={`!border-r-0 min-w-[100px]`}>
                                                                {/* <div className='w-full whitespace-nowrap flex items-center gap-1'> */}
                                                                    {/* {
                                                                        (key === 'credit' || key === 'debit' || key === 'balance') ?
                                                                        <span className="bdrep-rupee-sign">&#8377; </span>
                                                                        : null
                                                                    } */}
                                                                    {/* <AntdTooltip
                                                                        overlayClassName='!p-0' 
                                                                        overlayStyle={{ 
                                                                            fontSize: '12px',
                                                                        }}
                                                                        overlayInnerStyle={{
                                                                            textAlign: 'center',
                                                                        }}
                                                                        title={(key === 'particulars' && item?.particulars?.length > 65) ? item?.particulars : null}
                                                                    >
                                                                        <LanguageTranslator tag='label'>{item?.[key] || '-'}</LanguageTranslator>
                                                                    </AntdTooltip> */}
                                                                    <TextWithTooltip
                                                                        as='label'
                                                                        width={key === 'particulars' ? '520px' : ''} 
                                                                        text={item?.[key] || ''}
                                                                        className={`mb-0 truncate ${key === 'credit' ? 'text-xs font-medium text-[#00891A]' : key === 'debit' ? 'text-xs font-medium text-[#EE5A24]' : key === 'balance' ? 'text-xs' : '!text-[11px] text-[#111D31]'}`}
                                                                    />
                                                                {/* </div> */}
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            ))
                                        }
                                        {
                                            getLedgerReportData?.isLoading && <tr><td colSpan={100}>
                                                <div className='w-[calc(80vw-50px)] max-w-[1200px] h-[36px] flex items-center justify-center'>
                                                    <GenericSpinnerLoader/>
                                                </div>
                                                </td></tr>
                                        }
                                        <tr>
                                            <td colSpan={100}>
                                                <div ref={lastListElementRef} className='h-[30px] w-full' id="topMessageDiv"></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
    }

    const renderContent = () => {

        if (
            currentTab === "overview" &&
            (!currentTabData || getVendorProfileData?.isLoading)
        ) {
            return (
                <div className='h-full w-full flex items-center justify-center'>
                    <GenericSpinnerLoader />
                </div>
            );
        }


        switch (currentTab) {
            case 'overview':
                return <div>
                    <div className='mb-4 grid grid-cols-[.9fr_1fr_1fr_1fr_1fr] border border-borderSlateGrey rounded-[10px]'>
                        <div className='px-3.5 py-5 border-r border-borderSlateGrey'>
                            <Icons.SelectFile className='shrink-0 mb-3.5'/>
                            <h2 className='mb-1.5 text-[13px] font-medium text-fontBlack'>Total Purchase orders</h2>
                            <p className='mb-0 text-xl font-semibold'>{currentTabData?.po_asn_data?.total_po == 0 ? 0 : currentTabData?.po_asn_data?.total_po  || '-'}</p>
                        </div>
                        {
                            ordersData?.map((item, index) => (
                                <div key={index} className='px-6 py-5 flex flex-col gap-2 border-r last:border-r-0 border-borderSlateGrey'>
                                    <div className='mb-2 flex items-start justify-between gap-4'>
                                        <div>
                                            <p className='mb-0.5 text-[11px] text-[#4A5D7A]'>{item?.label || ''}</p>
                                            <h2 className='mb-0 text-xl font-semibold text-[#111D31]'>{item?.count == 0 ? 0 : item?.count || '-'}</h2>
                                        </div>
                                        <div>{item?.icon || ''}</div>
                                    </div>
                                    <div className='flex items-center justify-between gap-4'>
                                        <div>
                                            <p className='mb-0.5 text-[11px] text-[#4A5D7A]'>Qty</p>
                                            <div className='group relative'>
                                                <p className='mb-0 text-[14px] text-[#111D31] font-medium whitespace-nowrap'>{item?.qty == 0 ? 0 : formatNumber(item?.qty)?.short || '-'}</p>
                                                {formatNumber(item?.qty)?.full && <span className='generic-tooltip group-hover:visible group-hover:opacity-100'>{formatNumber(item?.qty)?.full || '-'}</span>}
                                            </div>
                                        </div>
                                        <div>
                                            <p className='mb-0.5 text-[11px] text-[#4A5D7A]'>Amount</p>
                                            <div className='group relative'>
                                                <p className='mb-0 text-[14px] text-[#111D31] font-medium whitespace-nowrap'>&#8377; {item?.amount == 0 ? 0 : formatNumber(item?.amount)?.short || '-'}</p>
                                                {formatNumber(item?.amount)?.full && <span className='generic-tooltip group-hover:visible group-hover:opacity-100'>{formatNumber(item?.amount)?.full || '-'}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div className='mb-4 grid grid-cols-[1fr_.45fr] gap-4'>
                    {/* <div className='mb-4'> */}
                        <div className='px-4 border border-borderSlateGrey rounded-[10px] grid grid-cols-[1fr_1fr_1fr]'>
                            <div className='py-3'>
                                {
                                    modifiedDataForGraph?.total_products > 0 ?
                                    <ResponsiveContainer width="100%" height={170}>  {/* 80% of 250 */}
                                        <PieChart>
                                            <Pie
                                                activeIndex={pieChartsActiveIndex}
                                                data={modifiedDataForGraph?.graphData}
                                                dataKey="value"
                                                nameKey="name"
                                                cx="50%"
                                                cy="50%"
                                                innerRadius={52} // Reduced to 80% of 65
                                                outerRadius={78} // Reduced to 80% of 100
                                                cornerRadius={4}
                                                paddingAngle={1.5}
                                                onMouseEnter={onPieEnter}
                                                onMouseLeave={() => setPieChartsActiveIndex(null)}
                                            >
                                                {modifiedDataForGraph?.graphData?.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                                ))}
                                            </Pie>
                                            {/* Custom Tooltip */}
                                            <Tooltip content={<ChartCustomTooltip />} />
                                            {/* <Tooltip /> */}
                                            {modifiedDataForGraph?.total_products !== undefined && 
                                            <g>
                                                <text 
                                                    x="50%" 
                                                    y="39%" 
                                                    textAnchor="middle" 
                                                    dominantBaseline="middle" 
                                                    className="text-[13px] font-medium fill-fontBlack"
                                                >
                                                    <LanguageTranslator>Total</LanguageTranslator>
                                                </text>
                                                <text 
                                                    x="50%" 
                                                    y="49%" 
                                                    textAnchor="middle" 
                                                    dominantBaseline="middle" 
                                                    className="text-[13px] font-medium fill-fontBlack"
                                                >
                                                    <LanguageTranslator>Products</LanguageTranslator>
                                                </text>
                                                <text 
                                                    x="50%" 
                                                    y="64%" 
                                                    textAnchor="middle" 
                                                    dominantBaseline="middle" 
                                                    className="text-xl font-semibold fill-fontBlack"
                                                >
                                                    {modifiedDataForGraph?.total_products}
                                                </text>
                                            </g>
                                            }
                                        </PieChart>
                                    </ResponsiveContainer>
                                    : <div className='p-[24px] mx-auto h-[150px] aspect-square shrink-0 bg-borderSlateGrey rounded-full flex items-center justify-center'>
                                        <div className='pt-[4px] bg-white rounded-full h-full w-full text-center text-fontBlack flex flex-col items-center justify-center'>
                                            <p className="mb-0 text-[13px] font-medium fill-fontBlack">
                                                <LanguageTranslator>Total</LanguageTranslator>
                                            </p>
                                            <p className="mb-1 text-[13px] font-medium fill-fontBlack">
                                                <LanguageTranslator>Products</LanguageTranslator>
                                            </p>
                                            <p className="mb-0 text-xl font-semibold fill-fontBlack">0</p>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className='px-8 py-5 border-r border-dashed border-borderSlateGrey flex flex-col gap-3 justify-center'>
                                {
                                    productStatusData?.map((item, index) => (
                                        <div key={index} className='flex items-center justify-between gap-3'>
                                            <div className='flex items-center gap-2.5'>
                                                <div>{item?.icon || ''}</div>
                                                <p className='mb-0 text-[11px] text-[#4A5D7A]'>{item?.label || ''}</p>
                                            </div>
                                            <p className='mb-0 text-base font-semibold text-[#111D31]'>{item?.count == 0 ? 0 : item?.count || '-'}</p>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className='px-8 py-5 flex flex-col justify-center'>
                                <div className='mb-4 flex items-center gap-2.5'>
                                    <div className='w-[8px] h-[8px] shrink-0 rounded-full bg-[#ECB80B] ring ring-[#ECB80B] ring-opacity-20'></div>
                                    <p className='mb-0 text-[11px] text-[#4A5D7A] whitespace-nowrap'>Costing & Sample Request</p>
                                </div>
                                <div className='mb-4 flex items-center justify-between gap-3'>
                                    <p className='mb-0 text-[11px] text-[#4A5D7A]'>Requested</p>
                                    <p className='mb-0 text-base font-semibold text-[#111D31]'>{currentTabData?.product_data?.costing_sampling_requested == 0 ? 0 : currentTabData?.product_data?.costing_sampling_requested || '-'}</p>
                                </div>
                                <div className='mb-9 flex items-center justify-between gap-3'>
                                    <p className='mb-0 text-[11px] text-[#4A5D7A]'>Pending Approval</p>
                                    <p className='mb-0 text-base font-semibold text-[#111D31]'>{currentTabData?.product_data?.costing_sampling_pending_approval == 0 ? 0 : currentTabData?.product_data?.costing_sampling_pending_approval || '-'}</p>
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col h-full'>
                            <div className='mb-3 px-3.5 py-2.5 flex items-center justify-between gap-4 bg-[#FAFAFA] rounded-[10px] h-full'>
                                <div>
                                    <div className='group relative'>
                                        <p className='mb-1 text-xl font-semibold text-fontBlack'>&#8377; {formatNumber(currentTabData?.product_data?.outstanding_amt)?.short || '-'}</p>
                                        {formatNumber(0)?.full && <span className='generic-tooltip group-hover:visible group-hover:opacity-100'>{formatNumber(0)?.full || '-'}</span>}
                                    </div>
                                    <p className='mb-0 text-[11px] text-[#4A5D7A]'>Outstanding Payable</p>
                                </div>
                                <div className='mt-[12px] p-[2px] h-[24px] w-[24px] rounded-[5px] shrink-0 flex items-center justify-center bg-[#5D5FEF]'><HandCoins size={18} color='white' strokeWidth={1.5} /></div>
                            </div>
                            <div className='grid grid-cols-2 gap-3 h-full'>
                                <div className='px-3.5 py-2.5 w-full rounded-[10px] h-full' style={{backgroundColor: getRangeCardBgColor(currentTabData?.po_grc_data?.otif || 0)}}>
                                    <p className='mb-1 text-[11px]'>OTIF</p>
                                    <p className='mb-1 text-xl font-semibold'>
                                        {/* {currentTabData?.po_grc_data?.otif == 0 ? 0 : currentTabData?.po_grc_data?.otif || '-'}% */}
                                          {currentTabData?.po_grc_data?.otif != null
                                        ? `${currentTabData?.po_grc_data?.otif}%`
                                        : '-'}
                                    </p>
                                    <div className="w-full h-[6px] rounded bg-gray-200 overflow-hidden">
                                        <div className="h-full" style={{ backgroundColor: getProgressColor(currentTabData?.po_grc_data?.otif || '0'), width: currentTabData?.po_grc_data?.otif || '0%' }}></div>
                                    </div>                                
                                </div>
                                <div className='px-3.5 py-2.5 w-full rounded-[10px] h-full' style={{backgroundColor: getRangeCardBgColor(currentTabData?.po_grc_data?.fulfill || 0)}}>
                                    <p className='mb-1 text-[11px]'>Fulfillment</p>
                                    <p className='mb-1 text-xl font-semibold'>
                                            {currentTabData?.po_grc_data?.fulfill != null
                                        ? `${currentTabData.po_grc_data.fulfill}%`
                                        : '-'}
                                    </p>
                                    <div className="w-full h-[6px] rounded bg-gray-200 overflow-hidden">
                                        <div className="h-full" style={{ backgroundColor: getProgressColor(currentTabData?.po_grc_data?.fulfill || '0'), width: currentTabData?.po_grc_data?.fulfill || '0%' }}></div>
                                    </div>  
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='border border-borderSlateGrey rounded-[10px] overflow-hidden'>
                        
                        <div className='px-4 py-3.5 flex items-center gap-3 bg-[#FAFBFD] border-b border-borderSlateGrey'>
                            <p className='mb-0 text-sm font-semibold text-fontBlack'>Vendor</p>
                            <GenericCustomButton
                                label={'All Details'}
                                rightIcon={<ChevronRight size={18} className='shrink-0 duration-200 group-hover:translate-x-1'/>}
                                className='group text-[13px] font-medium text-fontBlack flex items-center hover:opacity-75'
                                onClick={()=>handleChange('viewAllVendorDetails', vendorDetails)}
                            />
                        </div>
                        
                        <div className='px-4 py-4 grid grid-cols-5 gap-5 items-start'>
                            {
                                vendorDetails?.overview?.map((item, index) => (
                                    <div key={index} className=''>
                                        <p className='mb-0.5 text-[10px] text-[#6A6C70]'>{item?.label || ''}</p>
                                        <TextWithTooltip
                                            as='p'
                                            width={170}
                                            text={item?.value || ''}
                                            className='mb-1.5 text-xs font-medium text-[#111D31]'
                                        />
                                        {item?.attachment?.fileName && <div className='px-2 py-1 bg-[#F5F5F5] rounded-[3px] w-fit'>
                                            <GenericCustomButton
                                                type='underline2'
                                                label={item?.attachment?.fileName || 'View'}
                                                leftIcon={<FileText size={16} color='#AEAEB0' className='shrink-0' />}
                                                onClick={()=>handleChange('viewMedia', item?.attachment?.url || '')}
                                                className='max-w-[100px] truncate'
                                            />
                                        </div>}
                                    </div>
                                    
                                ))
                            }
                        </div>
                    </div>
                </div>
                break;
        
            case 'openPo':
                return <React.Fragment>
                    <VendorDetailsOpenPO
                        digivendStore={digivendStore}
                        tableHeadersMap={tableHeadersMap}
                     {...props} />
                </React.Fragment>
            
            case 'purchaseLedger': return renderPurchaseLedger();
            default:
                break;
        }
    }

    const getParentChildProps = () => {
        let payload = {
            animationType: "bottom",
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', margin: 0, position: "fixed", borderRadius: 0 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "70%", height: "80%" },
            closeModal: () => {setSelectedModal(false); setSelectedData(null);},
        }

        switch (selectedModal) {
            case "viewAllVendorDetails": {
                return {
                    closeModal: () => { setSelectedModal(null) },
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-end justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { minHeight: '25vh', height: 'auto', width: "100%" },
                    selectedData: selectedData,
                    vendorCode: props.vendorDetailsConfig?.vendorCode || "",
                    vendorName: props.vendorDetailsConfig?.vendorName || "",
                }
            }
            case "viewMedia": {
                let extName = getFileTypeFromUrl(selectedData);
                let type = getFileNameFromExt(extName)
                return {
                    animationType: "bottom",
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    closeModal: () => setSelectedModal(false),
                    filesData: [
						{
							fileUrl: selectedData || "",
							fileType: type,
						}
					]
                }
            }
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "viewAllVendorDetails": return ViewAllVendorDetails;
            case "viewMedia": return GenericMediaViewModal;
        }
    }

    console.log('currentTabData', currentTabData)
    console.log('props.vendorDetailsConfig', props.vendorDetailsConfig)

    return (
        <>
            <div className='flex flex-col h-full'>
                <div
                    style={{background: 'linear-gradient(91.93deg, rgba(93, 95, 239, 0.03) -4.38%, rgba(3, 182, 117, 0.03) 54.11%, rgba(236, 184, 11, 0.03) 118.55%'}}
                >
                    <GenericFormHeaderComponent
                        label={{
                            contentPrimary: () => (
                                <div className="flex items-start gap-3">
                                    {/* Vendor Avatar */}
                                    {/* <div className="w-[60px] h-[60px] border border-[#AEAE96] bg-borderSlateGrey rounded-[10px] flex items-center justify-center">
                                    </div> */}

                                    <div className='w-[32px] h-[32px] rounded-lg bg-black flex items-center justify-center'>
                                        <User size={20} color='white' />
                                    </div>

                                    <div>
                                        <div className="flex items-baseline gap-2">
                                            <h1 className="mb-0 text-2xl font-semibold">{props.vendorDetailsConfig?.vendorName || "-"}</h1>
                                            <div className='relative bottom-[2px] flex items-center gap-2'>
                                                <span className="text-[11px] text-fontBlack">{props.vendorDetailsConfig?.vendorCode || ""}</span>
                                                <GenericCustomButton
                                                    rightIcon={<SquareArrowOutUpRight 
                                                    color='#2681FF' 
                                                    size={16} 
                                                    className="shrink-0 hover:opacity-50" 
                                                    onClick={()=>handleChange('accessVendorPortal')}
                                                />}
                                                />
                                            </div>
                                        </div>

                                        {/* Rating */}
                                        <div className="mt-[10px] flex items-center gap-1">
                                            {renderRatingStars(rating || 0)}
                                            <span className="text-[11px]">{rating ? `${rating}/5` : '-/-'}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }}
                        rowEndComponent={() => (
                            <div className="px-2.5 py-2 mr-3 flex items-center gap-3 rounded-[10px] bg-white">
                                <Progress
                                    type="circle" 
                                    strokeColor={getProgressColor(onboardingProgress || 0)} 
                                    strokeWidth={15} 
                                    size={50} 
                                    percent={onboardingProgress} 
                                    format={() => <span className={`text-[11px] font-bold text-[${getProgressColor(onboardingProgress || 0)}]`}>{onboardingProgress ? `${onboardingProgress}%` : '-'}</span>}
                                />
                                <p className="mb-0 text-[11px] font-medium text-[#4A5D7A]">Vendor <br /> Onboarding</p>
                            </div>
                        )}
                        closeModal={props.closeModal}
                        rightContainerClassname='flex !items-start'
                    />
                    <GenericTabsComponent
                        tabsData={{
                            "overview": "Overview",
                            "openPo": "Open PO",
                            "purchaseLedger": "Purchase Ledger",
                        }}
                        current={currentTab}
                        handleTabChange={(val) => handleChange('changeTab', val)}
                        className='px-[15px]'
                    />
                </div>
                <div className='px-[15px] py-3 h-full overflow-auto'>
                    {renderContent()}
                </div>
            </div>
            {
                selectedModal && <ParentModal
                    getParentChildProps={getParentChildProps()}
                    childComponent={getChildComponent()}
                    closeModal={() => { setSelectedModal(false) }}
                />
            }
        </>
    )
}

export default VendorDetailsModal